export default "__VITE_ASSET__BkQmJbc6__"